'use client';

import { useState } from 'react';

const KEY = 'nt-search-history';
/** Figma 185:15235 „Naposledy ste hľadali“ lists four, newest first. */
const LIMIT = 4;

function readHistory(): string[] {
  try {
    const stored: unknown = JSON.parse(window.localStorage.getItem(KEY) ?? '[]');
    return Array.isArray(stored)
      ? stored
          .filter((term): term is string => typeof term === 'string' && term.trim() !== '')
          .slice(0, LIMIT)
      : [];
  } catch {
    // no storage (private mode, blocked) or a malformed value – no history
    return [];
  }
}

function writeHistory(terms: string[]) {
  try {
    if (terms.length) window.localStorage.setItem(KEY, JSON.stringify(terms));
    else window.localStorage.removeItem(KEY);
  } catch {
    // quota / private mode – the history is a convenience only
  }
}

const sameTerm = (a: string, b: string) => a.toLocaleLowerCase() === b.toLocaleLowerCase();

/** A submitted search (Enter, a result, a chip) goes to the top of the history. */
export function rememberSearch(term: string) {
  const value = term.trim();
  if (!value) return;
  writeHistory([value, ...readHistory().filter(other => !sameTerm(other, value))].slice(0, LIMIT));
}

/**
 * „Naposledy ste hľadali“ of this browser (localStorage). Read when the panel mounts – it renders
 * only after the search opens, never on the server.
 */
export function useSearchHistory() {
  const [terms, setTerms] = useState(readHistory);

  const update = (next: string[]) => {
    writeHistory(next);
    setTerms(next);
  };

  return {
    terms,
    remove: (term: string) => update(terms.filter(other => other !== term)),
    clear: () => update([]),
  };
}
